import React from 'react';
import PropTypes from 'prop-types';

const Upload = ({
  color = '#6E707C',
  className = '',
  height = '16',
  width = '16',
}) => {
  return (
    <svg className={className} fill="none" height={height} viewBox={`0 0 ${width} ${height}`} width={width} xmlns="http://www.w3.org/2000/svg">
      <path
        className="path"
        d="M7.5286 1.52859C7.78893 1.26825 8.21107 1.26825 8.4714 1.52859L11.1381 4.19526C11.3984 4.45561 11.3984 4.87772 11.1381 5.13807C10.8777 5.39842 10.4556 5.39842 10.1953 5.13807L8.66667 3.60947V10C8.66667 10.3682 8.3682 10.6667 8 10.6667C7.6318 10.6667 7.33333 10.3682 7.33333 10V3.60947L5.80474 5.13807C5.54439 5.39842 5.12228 5.39842 4.86193 5.13807C4.60158 4.87772 4.60158 4.45561 4.86193 4.19526L7.5286 1.52859Z"
        fill={color}
      />
      <path
        className="path"
        d="M2 7.33333C2.36819 7.33333 2.66667 7.6318 2.66667 8V10.8C2.66667 11.3711 2.66719 11.7593 2.6917 12.0593C2.71558 12.3516 2.75887 12.5011 2.81199 12.6053C2.93982 12.8562 3.1438 13.0602 3.39468 13.188C3.49895 13.2411 3.64841 13.2844 3.94069 13.3083C4.24075 13.3328 4.62895 13.3333 5.2 13.3333H10.8C11.3711 13.3333 11.7593 13.3328 12.0593 13.3083C12.3516 13.2844 12.5011 13.2411 12.6053 13.188C12.8562 13.0602 13.0602 12.8562 13.188 12.6053C13.2411 12.5011 13.2844 12.3516 13.3083 12.0593C13.3328 11.7593 13.3333 11.3711 13.3333 10.8V8C13.3333 7.6318 13.6318 7.33333 14 7.33333C14.3682 7.33333 14.6667 7.6318 14.6667 8V10.8275C14.6667 11.3642 14.6667 11.8071 14.6372 12.1679C14.6066 12.5426 14.5409 12.8871 14.376 13.2107C14.1203 13.7124 13.7124 14.1203 13.2107 14.376C12.8871 14.5409 12.5426 14.6066 12.1679 14.6372C11.8071 14.6667 11.3642 14.6667 10.8275 14.6667H5.17249C4.63583 14.6667 4.19292 14.6667 3.83212 14.6372C3.45739 14.6066 3.11291 14.5409 2.78936 14.376C2.28759 14.1203 1.87965 13.7124 1.62399 13.2107C1.45912 12.8871 1.39341 12.5426 1.36279 12.1679C1.33332 11.8071 1.33333 11.3642 1.33333 10.8275V8C1.33333 7.6318 1.63181 7.33333 2 7.33333Z"
        fill={color}
      />
    </svg>
  );
};

Upload.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
};

export default Upload;
